<script setup lang="ts">
import { computed } from 'vue'
import { EPage } from '@/shared/enum/page.enum'
import { useAppRouter } from '@/shared/composables/useAppRouter'
import ClaroHeader from '@/components/common/ClaroHeader.vue'
import LandingFooter from '@/components/common/Footer/index.vue'

const { currentRouteName } = useAppRouter()

const hasPadding = computed(() => currentRouteName.value !== EPage.PACKAGES)
const isLanding = computed(() => currentRouteName.value === EPage.LANDING)
const isNotFound = computed(() => currentRouteName.value === EPage.NOT_FOUND)
</script>

<template>
  <ClaroHeader />
  <main
    class="flex flex-col items-center mx-auto z-10 py-4 sm:py-6"
    :class="[
      hasPadding ? 'px-4 sm:px-6' : '',
      isLanding ? '' : 'h-mce-container',
      isNotFound ? 'max-w-5xl' : 'max-w-xl'
    ]"
  >
    <RouterView />
  </main>
  <LandingFooter v-if="isLanding" />
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  @apply transition-opacity duration-500;
}
.fade-enter,
.fade-leave-to {
  @apply opacity-0;
}

.h-mce-container {
  height: calc(100vh - 56px);
}
</style>
